import React, { Component } from "react";
import { connect } from "react-redux";

// State
import { adminLogin, clearErrors } from "../../../store/actions/user";

// CSS
import "../../../css/errors-success.css";

class AdminLoginForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			username: "",
			password: ""
		};

		this.componentCleanup = this.componentCleanup.bind(this);
	}

	componentDidMount() {
		window.addEventListener("beforeunload", this.componentCleanup);
	}

	componentCleanup() {
		this.props.clearErrors();
		window.removeEventListener("beforeunload", this.componentCleanup);
	}

	componentWillUnmount() {
		this.componentCleanup();
	}

	handleInputChange(event) {
		event.preventDefault();
		this.setState({
			[event.target.id]: event.target.value
		});
	}

	handleKeyPress(event, item_id) {
		if (event.key === "Enter") {
			this.handleSubmit();
		}
	}

	handleSubmit() {
		this.props.adminLogin(this.state.username, this.state.password);
	}

	render() {
		return (
			<div className="centered-form">
				<div className="form-field no-label-field">
					<label htmlFor="username">Username:</label>

					{this.props.errors.username && <div className="error msg_animate">{this.props.errors.username}</div>}
					<input type="text" name="username" id="username" value={this.state.username} placeholder="username" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
				</div>

				<div className="form-field no-label-field">
					<label htmlFor="password">Password:</label>

					{this.props.errors.password && <div className="error msg_animate">{this.props.errors.password}</div>}
					<input type="password" name="password" id="password" value={this.state.password} placeholder="password" onKeyPress={e => this.handleKeyPress(e)} onChange={event => this.handleInputChange(event)} />
				</div>

				<div className="btn_container">
					{this.props.errors.general && <div className="error msg_animate">{this.props.errors.general}</div>}
					<button className={`btn submit-btn` + (this.props.loading ? " loading" : "")} name="submit" value="submit" disabled={this.props.isLoading} onClick={() => this.handleSubmit()}>
						<span>Log In</span>
					</button>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		errors: state.user.errors,
		isLoading: state.user.isLoading
	};
};

export default connect(mapStateToProps, { adminLogin, clearErrors })(AdminLoginForm);



// WEBPACK FOOTER //
// ./src/components/admin/login/AdminLoginForm.js